export * from './EntityBase';
export * from './Market';
export * from './Metrics';
export * from './Property';
export * from './Address';
export * from './Marker';
export * from './MarketLeaderboard';
export * from './SaleInformation';
export * from './UnitType';
export * from './FloorPlan';
export * from './WalkScore';
export * from './Help';



// WEBPACK FOOTER //
// ./src/app/core/model/index.ts